import { ApiClient } from '@/api/ApiClient';

const state = {
  items: [],
  isLoading: false,
  hasNextPage: true,
};

const getters = {
  unread: state => {
    return state.items.filter(item => !item.isRead);
  },
};

const actions = {
  async fetch({ commit }, options = {}) {
    commit('setLoading', true);
    const response = await ApiClient.notifications.get({ params: options });
    commit('setNotifications', response.data);
    commit('setLoading', false);
  },
  async update({ commit }, { id, updatedAttributes }) {
    const response = await ApiClient.notifications.put({ id, body: updatedAttributes });
    if (response.status === 200) {
      commit('updateNotification', { id, attributes: response.data.data });
    }
    return response;
  },
  async markRead({ commit }, params) {
    const response = await ApiClient.notifications.markRead({ body: params });
    if (response.status === 200) {
      for (let id of params.rows) {
        commit('updateNotification', { id, attributes: { isRead: params.isRead } });
      }
    }
    return response;
  },
};

const mutations = {
  setNotifications(state, notifications) {
    const { data, nextPageUrl } = notifications;
    state.items = data;
    state.hasNextPage = !!nextPageUrl;
  },
  updateNotification(state, { id, attributes }) {
    const matchingNotification = state.items.find(item => item.id === id);
    if (matchingNotification) Object.assign(matchingNotification, attributes);
  },
  createNotification(state, notification) {
    if (state.items.find(item => item.id === notification.id)) return;
    state.items.unshift(notification);
  },
  clearNotifications(state) {
    state.items = [];
  },
  setLoading(state, value) {
    state.isLoading = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
